import { createSlice } from "@reduxjs/toolkit";

// تحميل البيانات المحفوظة من localStorage
const loadCarsFromStorage = () => {
  const savedCars = localStorage.getItem("compareCars");
  return savedCars ? JSON.parse(savedCars) : [];
};

export const compareCarsSlicer = createSlice({
  name: "CompareCarsSlicer",
  initialState: {
    cars: loadCarsFromStorage(),
    status: "empty",
    error: null,
  },
  reducers: {
    addCarToCompareList: (state, action) => {
      const newCar = action.payload;
      if (state.cars.some(car => car.uuid === newCar.uuid)) {
        state.status = "exists";
        state.error = "Car already exists in the compare list";
      } else if (state.cars.length === 3) {
        state.status = "full";
        state.error = "Cars List To Compare is Full - Remove one Car From it";
      } else {
        state.cars.push(newCar);
        state.error = null; // تنظيف الأخطاء
        state.status = state.cars.length === 3 ? "full" : "not full";
        localStorage.setItem("compareCars", JSON.stringify(state.cars));
      }
      console.log(`Compare Cars List Now: ${JSON.stringify(state.cars)}`);
    },
    removeCarFromCompareList: (state, action) => {
      state.cars = state.cars.filter(car => car.uuid !== action.payload.uuid);
      state.error = null; // تنظيف الأخطاء
      state.status = state.cars.length === 0 ? "empty" : "not full";
      localStorage.setItem("compareCars", JSON.stringify(state.cars));
      console.log(`Compare Cars List After Removal: ${JSON.stringify(state.cars)}`);
    },
  },
});

// Export Actions
export const { addCarToCompareList, removeCarFromCompareList } = compareCarsSlicer.actions;
// Export Reducer
export default compareCarsSlicer.reducer;
